import { Component, Input } from '@angular/core';
import { Grant } from '../../_models/grant';

@Component({
  moduleId: module.id,
  selector: 'insuranceresidence',
  templateUrl: 'insuranceresidence.component.html',
  styleUrls: ['insuranceresidence.component.css']
})
export class InsuranceResidenceComponent {
  @Input()
  public grant: Grant;
}




// WEBPACK FOOTER //
// ./src/app/grant-form/insuranceresidence/insuranceresidence.component.ts